import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Stories from "@/pages/home/components/Stories";
import Years from "@/pages/home/components/Years";
import Notes from "@/pages/home/components/Notes";
import Voices from "@/pages/home/components/Voices";
import Themes from "@/pages/home/components/Themes";
import Guide from "@/pages/home/components/Guide";
import Faq from "@/pages/home/components/Faq";
import Subscribe from "@/pages/home/components/Subscribe";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <Stories />
        <Years />
        <Notes />
        <Voices />
        <Themes />
        <Guide />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
}